import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useAuthContext } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/auth";
import { UserAvatar } from "../Avatars/UserAvatar";
import Dropdown from "../Dropdown/Dropdown";
import { FiLogOut } from "react-icons/fi";

export function ProfileMenu() {
  const { state: authState, dispatch } = useAuthContext();
  const navigate = useNavigate();

  const content = (
    <div className="min-w-[200px]">
      <div className="block px-4 py-4 text-sm leading-6 text-gray-900 border-b border-gray-200 pointer">
        <span>Signed in as: </span>
        <span className="font-bold">{authState.me?.email}</span>
      </div>

      <button
        onClick={() => logout(dispatch, navigate)}
        className="w-full flex items-center gap-2 px-4 py-4 text-sm leading-6 text-gray-900 hover:bg-gray-100 rounded-b-2xl transition-colors"
      >
        <FiLogOut className="h-4 w-4 text-gray-600" />
        <span>Sign out</span>
      </button>
    </div>
  );

  return (
    <Dropdown
      autoClose={false}
      button={<ProfileMenuButton name={authState.me?.name} />}
      content={content}
    />
  );
}

export function ProfileMenuButton({ name }) {
  return (
    <button
      type="button"
      className="flex items-center gap-3 px-3 py-1.5 rounded-full 
                 hover:bg-gray-100
                 transition"
      aria-haspopup="true"
      aria-label="Open user menu"
    >
      <UserAvatar name={name} />
      <span className="hidden lg:flex items-center gap-1">
        <span className="text-sm font-semibold text-gray-900 truncate">
          {name}
        </span>
        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
      </span>
    </button>
  );
}
